<template>
  <div class="main-page">
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <!-- Master Page Start -->
          <div v-if="!loading && records.length > 0" class="col-12">
            <Fieldset :key="index" :toggleable="true" class="mb-4">
              <template #legend>
                <div class="text-primary">
                  {{ $t("caps_mall") }}
                </div>
              </template>
              <div class="page-records">
                <DataTable
                  :lazy="true"
                  :loading="loading"
                  :value="records"
                  dataKey="applicant_id"
                  @sort="onSort($event)"
                  class=""
                  :showGridlines="false"
                  :rowHover="false"
                  responsiveLayout="scroll"
                  breakpoint="960px"
                >
                  <Column
                    field="caps_institutions_list_institution_name"
                    :header="$t('institution_name')"
                  >
                    <template #body="{ data }">
                      {{ data.caps_institutions_list_institution_name }}
                    </template>
                  </Column>
                  <Column
                    field="programme_choice_title"
                    :header="$t('programme_name')"
                  >
                    <template #body="{ data }">
                      {{ data.programme_choice_title }}
                    </template>
                  </Column>
                  <Column field="acceptance_status" :header="$t('status')">
                    <template #body="{ data }">
                      <Badge
                        size="medium"
                        style="font-size: 0.8rem"
                        class="px-3"
                        :value="data.acceptance_status"
                        :severity="
                          data.acceptance_status == pending
                            ? 'warning'
                            : data.acceptance_status == accepted
                            ? 'success'
                            : 'danger'
                        "
                      ></Badge>
                    </template>
                  </Column>
                  <!-- <Column
                            field="activity_type"
                            :header="$t('scenario')"
                          >
                            <template #body="{ data }">
                              {{ data.activity_type }}
                            </template>
                          </Column> -->
                  <Column field="action" :header="$t('action')">
                    <template #body="{ data }">
                      <Button
                        :label="$t('accept_offer')"
                        class="p-button-success p-button-text mx"
                        :class="
                          data.acceptance_status == accepted
                            ? 'text-green-500 font-bold'
                            : 'text-blue-200'
                        "
                        style="font-size: 13px"
                        :disabled="
                          data.acceptance_status == accepted ? false : true
                        "
                        @click="
                          confirmAcceptance(
                            data.programme_choice_id,
                            data.programme_choice_title,
                            data.caps_institutions_list_institution_name
                          )
                        "
                      />
                    </template>
                  </Column>
                </DataTable>
              </div>
            </Fieldset>
            <!-- page loading indicator -->
            <template v-if="loading">
              <div
                v-show="loading"
                class="flex align-items-center justify-content-center text-gray-500"
              >
                <div>
                  <ProgressSpinner style="width: 30px; height: 30px" />
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { defineAsyncComponent, ref } from "vue";
import { PageMixin } from "../../mixins/page.js";
import { ListPageMixin } from "../../mixins/listpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "listCapsmallselectionsPage",
  components: {},
  mixins: [PageMixin, ListPageMixin],
  props: {
    primaryKey: {
      type: String,
      default: "",
    },
    pageName: {
      type: String,
      default: "caps_mall_selections",
    },
    routeName: {
      type: String,
      default: "capsmallprogrammeapply",
    },
    apiPath: {
      type: String,
      default: "caps_mall_selections/index",
    },
    mergeRecords: {
      type: Boolean,
      default: false,
    },
    multiCheckbox: {
      type: Boolean,
      default: false,
    },
    msgBeforeDelete: {
      type: String,
      default: "Are you sure you want to delete this record?",
    },
  },
  data() {
    return {
      accepted: "Accepted",
      pending: "Pending",
      completed: "Completed",
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        //set browser page title
        return "Caps Mall Selections";
      },
    },
    records: {
      get: function () {
        return this.$store.getters["caps_mall_selections/records"];
      },
      set: function (value) {
        this.$store.commit("caps_mall_selections/setRecords", value);
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["caps_mall_selections/currentRecord"];
      },
      set: function (value) {
        this.$store.commit("caps_mall_selections/setCurrentRecord", value);
      },
    },
  },
  watch: {
    apiUrl: function () {
      this.load();
    },
  },
  methods: {
    ...mapActions("caps_mall_selections", ["fetchRecords", "deleteRecord"]),
    ...mapActions("applicants", ["acceptOffer"]),
    getActionMenuModel(data) {
      return [];
    },
    load: function () {
      if (!this.loading) {
        this.loading = true;
        this.currentRecord = null;
        let url = this.apiUrl;
        let payload = {
          url,
          merge: this.mergeRecords,
        };
        this.fetchRecords(payload).then(
          (response) => {
            this.loading = false;
            this.ready = true;
            this.totalRecords = response.total_records;
            this.recordCount = response.record_count;
            this.pagination.rowsNumber = this.totalRecords;
            window.scrollTo(0, 0);
          },
          (response) => {
            this.loading = false;
            this.showPageRequestError(response);
          }
        );
      }
    },
    confirmAcceptance(programme_id, programme_name, institution_name) {
      this.$emit("acceptOffer", programme_id, programme_name, institution_name);
    },
  },
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
